import { useTranslation } from 'react-i18next';
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/Domain/components/Shared/Form/Form';
import { Input } from '@/Domain/components/Shared/Input/Input';
import { AutosizeTextarea } from '@/Domain/components/Shared/Textarea/Textarea';
import { useMcpForm } from '@/Domain/hooks/Action/useMcpForm/useMcpForm';

export const McpForm = () => {
  const { t } = useTranslation('mcp_page');
  const { form } = useMcpForm();

  return (
    <Form {...form}>
      <form>
        <div className="flex flex-col gap-6">
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t('form.name_label')}</FormLabel>
                <FormDescription>{t('form.name_sublabel')}</FormDescription>
                <FormControl>
                  <Input placeholder={t('form.name_placeholder')} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="description"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t('form.description_label')}</FormLabel>
                <FormDescription>{t('form.description_sublabel')}</FormDescription>
                <FormControl>
                  <AutosizeTextarea
                    placeholder={t('form.description_placeholder')}
                    {...field}
                    minHeight={200}
                    className="px-4"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="command"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t('form.command_label')}</FormLabel>
                <FormDescription>{t('form.command_sublabel')}</FormDescription>
                <FormControl>
                  <Input placeholder={t('form.command_placeholder')} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </form>
    </Form>
  );
};
